import {createBrowserRouter, Outlet, RouterProvider} from "react-router-dom";
import Layout from "./layout";
import DashboardPage from "./app/dashboard/page";
import UsersPage from "./app/users/UsersPage";
import UserDetailPage from "./app/users/UserDetailPage";
import {UserProvider} from "@/app/auth/UserContext.tsx";
import {ProtectedRoute} from "./app/auth/ProtectedRoute";
import Callback from '@/app/auth/Callback';
import WorkerTasksPage from "@/app/worker-tasks/page";
import NotFoundPage from "@/app/not-found/page.tsx";
import CandidatesPage from "@/app/candidates/page.tsx";
import CandidateDetailPage from "@/app/candidates/detail.tsx";
import SchoolsPage from "@/app/schools/page.tsx";
import SchoolDetailPage from "@/app/schools/detail.tsx";
import CompaniesPage from "@/app/companies/page.tsx";
import CompanyDetailPage from "@/app/companies/detail.tsx";
import PluginStatusPage from "@/app/plugin-status/page.tsx";
import PluginLogsPage from "@/app/plugin-logs/page.tsx";
import SubscriptionsPage from "@/app/subscriptions/page.tsx";
import SubscriptionDetailPage from "@/app/subscriptions/detail.tsx";
import OrganizationsPage from "@/app/organizations/page.tsx";
import OrganizationDetailPage from "@/app/organizations/detail.tsx";
import PromoCodesPage from "@/app/promo-codes/page.tsx";
import CampaignsPage from "@/app/campaigns/page.tsx";
import MeetsPage from "@/app/meets/page.tsx";
import MessagesPage from "@/app/messages/page.tsx";
import ScrapingStatsPage from "@/app/scraping-stats/page.tsx";
import LlmCostsPage from "@/app/llm-costs/page.tsx";
import PluginStoreVersionsPage from "@/app/plugin-store-versions/page.tsx";
import AdminOpsPage from "@/app/admin-ops/page.tsx";
import SkillsPage from "@/app/skills/page.tsx";
import LanguagesPage from "@/app/languages/page.tsx";
import CertificationsPage from "@/app/certifications/page.tsx";
import InterestsPage from "@/app/interests/page.tsx";
import DataTransferPage from "@/app/data-transfer/page.tsx";
import FeatureFlagsPage from "@/app/feature-flags/page.tsx";
import CompanyClassificationPage from "@/app/company-classification/page.tsx";
import WorkflowTemplatesPage from "@/app/workflow-templates/page.tsx";
import MessageTemplatesPage from "@/app/message-templates/page.tsx";
import BackupVerifyPage from "@/app/backup-verify/page.tsx";
import SecurityPage from "@/app/security/page.tsx";
import MailDiagnosticPage from "@/app/mail-diagnostic/page.tsx";
import TestClassificationPage from "@/app/test-classification/page.tsx";
import InterviewToolsPage from "@/app/interview-tools/page.tsx";
import ClassificationsPage from "@/app/classifications/page.tsx";
import QuotasPage from "@/app/quotas/page.tsx";
import BrowserFarmPage from "@/app/browser-farm/page.tsx";
import SupportPage from "@/app/support/page.tsx";
import SupportDetailPage from "@/app/support/detail.tsx";
import GeoResolutionPage from "@/app/geo-resolution/page.tsx";
import CronJobsPage from "@/app/cron-jobs/page.tsx";
import SettingsPage from "@/app/settings/page.tsx";

function Root() {
    return (
        <UserProvider>
          <Outlet/>
        </UserProvider>
    );
}

const router = createBrowserRouter([
  {
    element: <Root />,
    children: [
      {
        path: "/dashboard",
        element: (
          <ProtectedRoute>
            <Layout><DashboardPage /></Layout>
          </ProtectedRoute>
        )
      },
      {
        path: "/worker-tasks",
        element: (
          <ProtectedRoute>
            <Layout><WorkerTasksPage /></Layout>
          </ProtectedRoute>
        )
      },
        {
            path: "/candidates",
            element: (
                <ProtectedRoute>
                    <Layout><CandidatesPage /></Layout>
                </ProtectedRoute>
            )
        },
        {
            path: "/candidates/:id",
            element: (
                <ProtectedRoute>
                    <Layout><CandidateDetailPage /></Layout>
                </ProtectedRoute>
            )
        },
        {
            path: "/schools",
            element: (
                <ProtectedRoute>
                    <Layout><SchoolsPage /></Layout>
                </ProtectedRoute>
            )
        },
        {
            path: "/schools/:id",
            element: (
                <ProtectedRoute>
                    <Layout><SchoolDetailPage /></Layout>
                </ProtectedRoute>
            )
        },
        {
            path: "/companies",
            element: (
                <ProtectedRoute>
                    <Layout><CompaniesPage /></Layout>
                </ProtectedRoute>
            )
        },
        {
            path: "/companies/:id",
            element: (
                <ProtectedRoute>
                    <Layout><CompanyDetailPage /></Layout>
                </ProtectedRoute>
            )
        },
        {
            path: "/skills",
            element: (
                <ProtectedRoute>
                    <Layout><SkillsPage /></Layout>
                </ProtectedRoute>
            )
        },
        {
            path: "/languages",
            element: (
                <ProtectedRoute>
                    <Layout><LanguagesPage /></Layout>
                </ProtectedRoute>
            )
        },
        {
            path: "/certifications",
            element: (
                <ProtectedRoute>
                    <Layout><CertificationsPage /></Layout>
                </ProtectedRoute>
            )
        },
        {
            path: "/interests",
            element: (
                <ProtectedRoute>
                    <Layout><InterestsPage /></Layout>
                </ProtectedRoute>
            )
        },
        {
          path: "/plugins",
          element: (
              <ProtectedRoute>
                  <Layout><PluginStatusPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/plugin-logs",
          element: (
              <ProtectedRoute>
                  <Layout><PluginLogsPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/scraping-stats",
          element: (
              <ProtectedRoute>
                  <Layout><ScrapingStatsPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/llm-costs",
          element: (
              <ProtectedRoute>
                  <Layout><LlmCostsPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/plugin-store-versions",
          element: (
              <ProtectedRoute>
                  <Layout><PluginStoreVersionsPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/subscriptions",
          element: (
              <ProtectedRoute>
                  <Layout><SubscriptionsPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/subscriptions/:userId",
          element: (
              <ProtectedRoute>
                  <Layout><SubscriptionDetailPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/support",
          element: (
              <ProtectedRoute>
                  <Layout><SupportPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/support/:id",
          element: (
              <ProtectedRoute>
                  <Layout><SupportDetailPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/organizations",
          element: (
              <ProtectedRoute>
                  <Layout><OrganizationsPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/organizations/:id",
          element: (
              <ProtectedRoute>
                  <Layout><OrganizationDetailPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/promo-codes",
          element: (
              <ProtectedRoute>
                  <Layout><PromoCodesPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/campaigns",
          element: (
              <ProtectedRoute>
                  <Layout><CampaignsPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/meets",
          element: (
              <ProtectedRoute>
                  <Layout><MeetsPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/messages",
          element: (
              <ProtectedRoute>
                  <Layout><MessagesPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/data-transfer",
          element: (
              <ProtectedRoute>
                  <Layout><DataTransferPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/admin-ops",
          element: (
              <ProtectedRoute>
                  <Layout><AdminOpsPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/feature-flags",
          element: (
              <ProtectedRoute>
                  <Layout><FeatureFlagsPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/company-classification",
          element: (
              <ProtectedRoute>
                  <Layout><CompanyClassificationPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/workflow-templates",
          element: (
              <ProtectedRoute>
                  <Layout><WorkflowTemplatesPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/message-templates",
          element: (
              <ProtectedRoute>
                  <Layout><MessageTemplatesPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/backup-verify",
          element: (
              <ProtectedRoute>
                  <Layout><BackupVerifyPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/security",
          element: (
              <ProtectedRoute>
                  <Layout><SecurityPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/mail-diagnostic",
          element: (
              <ProtectedRoute>
                  <Layout><MailDiagnosticPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/quotas",
          element: (
              <ProtectedRoute>
                  <Layout><QuotasPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/browser-farm",
          element: (
              <ProtectedRoute>
                  <Layout><BrowserFarmPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/test-classification",
          element: (
              <ProtectedRoute>
                  <Layout><TestClassificationPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/interview-tools",
          element: (
              <ProtectedRoute>
                  <Layout><InterviewToolsPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/classifications",
          element: (
              <ProtectedRoute>
                  <Layout><ClassificationsPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/geo-resolution",
          element: (
              <ProtectedRoute>
                  <Layout><GeoResolutionPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/cron-jobs",
          element: (
              <ProtectedRoute>
                  <Layout><CronJobsPage /></Layout>
              </ProtectedRoute>
          )
        },
        {
          path: "/settings",
          element: (
              <ProtectedRoute>
                  <Layout><SettingsPage /></Layout>
              </ProtectedRoute>
          )
        },
      {
        path: "/callback",
        element: (
            <Callback/>
        )
      },
      {
        path: "/users",
        element: (
          <ProtectedRoute>
            <Layout><UsersPage /></Layout>
          </ProtectedRoute>
        )
      },
      {
        path: "/users/:userId",
        element: (
          <ProtectedRoute>
            <Layout><UserDetailPage /></Layout>
          </ProtectedRoute>
        )
      },
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <Layout><DashboardPage /></Layout>
          </ProtectedRoute>
        )
      },
        {
            path: "*", element: <ProtectedRoute>
                <Layout><NotFoundPage /></Layout>
            </ProtectedRoute>
        },
    ]
  }
]);

export default function AppRouter() {
    return <RouterProvider router={router}/>;
}
